import React from 'react';

import { Spacing } from '@kezios/design-system';
import { Flex, Stack, Text } from '@mantine/core';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

import css from './Item.module.css';

export type TextItemProps = {
  title: string;
  ctas: {
    text: string;
    link: string;
  }[];
};

export type ImageItemProps = {
  image: string;
};

export type ItemProps = TextItemProps & ImageItemProps;

export const Item = ({ title, ctas, image }: ItemProps) => {
  const router = useRouter();
  const goToDocumentation = () => {
    router.push(ctas[0].link);
  };
  return (
    <Stack
      className={css.container}
      onClick={e => {
        const isAlreadyLink = e.target instanceof HTMLAnchorElement;
        if (isAlreadyLink) return;

        goToDocumentation();
      }}
    >
      <TextItem title={title} ctas={ctas} />
      <ImageItem image={image} />
    </Stack>
  );
};

export const TextItem = ({ title, ctas }: TextItemProps) => {
  return (
    <Stack className={css.child} gap={Spacing.s1} w={'100%'}>
      <Stack className={css.heading} id="card-heading">
        <Text variant="textXl.bold" c="gray.6">
          {title}
        </Text>
        <Text variant="textXl.bold" c="gray.6">
          →
        </Text>
      </Stack>
      {ctas.map((cta, index) => (
        <Text
          key={index}
          variant="textMd.regular"
          component={Link}
          href={cta.link}
          c="gray.6"
          className={css.link}
        >
          {cta.text}
        </Text>
      ))}
    </Stack>
  );
};

export const ImageItem = ({ image }: ImageItemProps) => {
  return (
    <Flex
      className={css.child}
      h={'100%'}
      w={'100%'}
      align={'center'}
      justify={'center'}
    >
      <Image alt="tutorial" src={image} fill />
    </Flex>
  );
};
